import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';
import image404 from '../assets/images/404.png';
import Wrapper from '../layouts/Wrapper';
import Spinner from '../components/Spinner';
import Api from '../api';

function PageNotFound() {
  const location = useLocation();
  const [urlsLoading, setUrlsLoading] = useState(true);
  const fullUrl = `${window.location.origin}${location.pathname}${location.search}${location.hash}`;
  const navigate = useNavigate();
  const lang = Cookies.get('i18next') || 'en';
  const { translations, loading } = useSelector((state) => state.translation);
  useEffect(() => {
    (async () => {
      setUrlsLoading(true);
      const { data } = await Api.getRedirectUrls(`/${lang}`);
      const existUrl = data?.data.find((item) => item.old_url === fullUrl);
      if (existUrl) {
        navigate(existUrl.new_url.replace(window.location.origin, ''));
      }
      setUrlsLoading(false);
    })();
  }, []);
  return (
    <Wrapper>
      {loading || urlsLoading ? <Spinner width={100} height={100} /> : (
        <div className="page-404">
          <img src={image404} alt="404" />
          <h2 className="not-found-title">{translations?.page_not_found[lang]}</h2>
          <button
            onClick={() => navigate(`/${lang}`)}
            className="not-found-btn"
            type="button"
          >
            {translations.go_home[lang]}
          </button>
        </div>
      )}
    </Wrapper>
  );
}

export default PageNotFound;
